import _isNil from "lodash/isNil";
/* eslint-disable no-param-reassign */
import produce from 'immer';
import { emptyFocus } from 'redux/reducers/cellInfo/initialState';
var cellInfoUnfocus = produce(function (draft, action) {
  var _action$payload;
  var _ref = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {},
    layer = _ref.layer;
  if (_isNil(layer)) {
    draft.focus.forEach(function (__, i) {
      draft.focus[i] = emptyFocus;
    });
    return;
  }
  draft.focus[layer] = emptyFocus;
});
export default cellInfoUnfocus;